import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiCheckCircle, FiAlertTriangle, FiShield, FiMapPin, FiMessageCircle, FiLock } from 'react-icons/fi';

const Safety = () => {
  const navigate = useNavigate();

  const items = [
    { icon: <FiCheckCircle size={20} />, title: 'Photo Verification', desc: 'Verify your photos to earn a blue checkmark', color: '#3B82F6', action: 'Verify Now' },
    { icon: <FiAlertTriangle size={20} />, title: 'Report User', desc: 'Report inappropriate behavior or fake profiles', color: '#EF4444', action: 'Report' },
    { icon: <FiShield size={20} />, title: 'Block User', desc: 'Block someone to stop all communication', color: '#F59E0B', action: 'Manage' },
    { icon: <FiMapPin size={20} />, title: 'Location Privacy', desc: 'Your exact location is never shared. Only approximate distance is shown.', color: '#22C55E' },
    { icon: <FiMessageCircle size={20} />, title: 'Scam Awareness', desc: 'Never send money or share financial information with matches.', color: '#8B5CF6' },
    { icon: <FiLock size={20} />, title: 'Safety Tips', desc: 'Meet in public places, tell a friend, and trust your instincts.', color: '#EC4899' },
  ];

  return (
    <div style={{ minHeight: '100vh', background: '#08080C', paddingBottom: 40 }}>
      <div style={{ padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 12 }}>
        <button onClick={() => navigate(-1)} style={{ background: 'none', border: 'none', color: '#A1A1AA', cursor: 'pointer' }}>
          <FiArrowLeft size={22} />
        </button>
        <h1 style={{ fontSize: 22, fontWeight: 700 }}>Safety Center</h1>
      </div>

      <div style={{ padding: '0 20px' }}>
        <div style={{
          padding: 20, borderRadius: 20, marginBottom: 24,
          background: 'linear-gradient(135deg, rgba(34,197,94,0.08), rgba(59,130,246,0.08))',
          border: '1px solid rgba(34,197,94,0.15)',
        }}>
          <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 6 }}>Your Safety Matters</h3>
          <p style={{ fontSize: 13, color: '#A1A1AA', lineHeight: 1.5 }}>
            We are committed to making VIBE a safe platform. Your exact location is never publicly displayed.
          </p>
        </div>

        {items.map((item, i) => (
          <div key={i} style={{
            display: 'flex', alignItems: 'flex-start', gap: 14, padding: '16px',
            marginBottom: 8, borderRadius: 16,
            background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.04)',
          }}>
            <div style={{
              width: 40, height: 40, borderRadius: 12,
              background: `${item.color}12`, color: item.color,
              display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            }}>{item.icon}</div>
            <div style={{ flex: 1 }}>
              <h4 style={{ fontSize: 14, fontWeight: 600, marginBottom: 2 }}>{item.title}</h4>
              <p style={{ fontSize: 12, color: '#71717A', lineHeight: 1.5 }}>{item.desc}</p>
            </div>
            {item.action && (
              <button style={{
                padding: '6px 12px', borderRadius: 8, border: `1px solid ${item.color}30`,
                background: `${item.color}08`, color: item.color,
                fontSize: 12, fontWeight: 500, cursor: 'pointer', fontFamily: 'Inter',
                flexShrink: 0,
              }}>{item.action}</button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Safety;
